import React from 'react';

import {getPartyDisplayString} from 'parties/GetPartyDisplayString';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import {Optional} from 'util/Types';

import {AuthorGraphQL} from '../../graphql-fragments/parties/__generated/AuthorGraphQL';

interface AuthorsProps {
  authors: Optional<Array<AuthorGraphQL>>;
}

export default function Authors(props: AuthorsProps): JSX.Element {
  if (!props.authors) {
    return <span />;
  }
  const displayNames = props.authors.map((author) => getPartyDisplayString(author));
  if (displayNames.length > 3) {
    const [name1, name2, ...rest] = displayNames;
    return (
      <span>
        {`${name1}, ${name2}, `}
        <Tooltip placement={FloatingPlacement.BOTTOM} text={rest.join(', ')}>
          <span>+{rest.length}</span>
        </Tooltip>
      </span>
    );
  }
  return <span>{displayNames.join(', ')}</span>;
}
